import * as React from 'react';
import styled from 'styled-components';

const ArrowSVG = styled.svg<{ direction: string | number | undefined }>`
	transform: ${({ direction }) =>
		direction === 'right'
			? 'rotate(270deg)'
			: direction === 'up'
				? 'rotate(180deg)'
				: direction === 'left'
					? 'rotate(90deg)'
					: ''};
`;

const Arrow = ({ direction, ...props }: React.SVGProps<SVGSVGElement>) => (
	<ArrowSVG
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 24 14"
		direction={direction}
		{...props}
	>
		<path d="M21.937.495 23.88 2.44 13.289 13.035a1.826 1.826 0 0 1-2.59 0L.101 2.44 2.045.497l9.946 9.944L21.937.495Z" />
	</ArrowSVG>
);
export default Arrow;
